export const EmployeeSearchConfig: Record<string, string>[] = [
  {
    key: "employeeId",
    displayValue: "Employee Id",
    regex: ""
  },
  {
    key: "email",
    displayValue: "Email",
    regex: ""
  },
  {
    key: "phoneNumber",
    displayValue: "Phone number",
    regex: ""
  },
  {
    key: "firstName",
    displayValue: "Firstname",
    regex: ""
  },
  {
    key: "lastName",
    displayValue: "Lastname",
    regex: ""
  },
  {
    key: "alias",
    displayValue: "Alias",
    regex: ""
  }
];
